<template>
  <div>
    <CardCadastro size="100">
      <div slot="header">
        <h4 class="title">Parecer / Vídeo</h4>
      </div>
      <div slot="body">
        <div class="md-layout">
          <div class="md-layout-item md-size-70">
            <field>
              <md-textarea
                v-model="item.parecer"
                style="height: 100px; width: 90%"
                class="form-control"
                placeholder="Parecer"
                :disabled="!enable_edit"
              ></md-textarea>
            </field>
          </div>
          <div class="md-layout-item md-size-30">
            <field>
              <md-textarea
                v-model="item.video"
                style="height: 100px; width: 90%"
                class="form-control"
                placeholder="Vídeo"
                :disabled="!enable_edit"
              ></md-textarea>
            </field>
          </div>
        </div>
      </div>
    </CardCadastro>
  </div>
</template>
<script>
import CardCadastro from "../../../components/CardCadastro";
export default {
  components: { CardCadastro },
  props: {
    item: {
      type: Object,
      default: { parecer: "", video: "" }
    },
    enable_edit:{
          type: Boolean,
          default: true
    },
  },
  model: {
    prop: "item",
    event: "update"
  }
};
</script>